import { Injectable } from '@angular/core';
import { IToasterData } from './toaster.data';
import { Observable } from 'rxjs';
import { getToasterData } from './toaster.reducer';
import { Store } from '@ngrx/store';
import { Toast, ToasterService as ToastService } from 'angular2-toaster';

@Injectable()
export class ToasterStore {
  onToastAdd$: Observable<Toast> = this._toastService.addToast;

  constructor(
    private _store: Store<any>,
    private _toastService: ToastService
  ) {}

  getToasterData(): Observable<IToasterData> {
    return this._store.select(getToasterData);
  }
}
